import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import TextField from "@material-ui/core/TextField";
import { AccordionSummary } from "@material-ui/core";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Accordion from "@material-ui/core/Accordion";
import {
  ACCORDION_USER_SECURITY_CREDENTIALS,
  CREDENTIALS_TYPE_EMAIL,
  CREDENTIALS_TYPE_PHONE,
  MESSAGE_USER_CREDENTIAL_UPDATE,
  MESSAGE_USER_CREDENTIAL_VALIDATE,
} from "../../../../../utils/constants";
import { putCredentialUpdate, putValidateSecurityCredentials } from "../../../../../api";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import AlertDialog from "../../../../../components/custom-dialog/CustomDialogComponent";
import Tooltip from "@material-ui/core/Tooltip";
import { formatValidationDate } from "../../../../../utils/utils";
import { useIntl } from "react-intl";

const UserCredentialsComponent = ({ classes, user, expanded, handleSetExpanded, id, idCrm, handleGetUser }) => {
  const intl = useIntl();

  const [securityEmail, setSecurityEmail] = useState("");
  const [securityPhone, setSecurityPhone] = useState("");
  const [openInfo, setOpenInfo] = useState(false);

  useEffect(() => {
    if (user?.emailSeguridad) {
      setSecurityEmail(user?.emailSeguridad);
    }
    if (user?.movilSeguridad) {
      setSecurityPhone(user?.movilSeguridad);
    }
  }, [user]);

  const handleSetSecurityEmail = (value) => {
    setSecurityEmail(value?.toUpperCase());
  };

  const handleSetSecurityPhone = (value) => {
    setSecurityPhone(value);
  };

  const handleRestoreData = () => {
    setSecurityEmail(user.emailSeguridad || "");
    setSecurityPhone(user.movilSeguridad || "");
  };

  const handleResponse = () => {
    handleRestoreData();
    handleGetUser();
  };

  const handleUpdateSecurityCredentials = (type) => {
    const body =
      type === CREDENTIALS_TYPE_PHONE
        ? {
            credencialTelefono: securityPhone,
            credencialEmail: user.emailSeguridad,
          }
        : {
            credencialTelefono: user.movilSeguridad,
            credencialEmail: securityEmail,
          };
    putCredentialUpdate(idCrm, id, body, handleResponse, {
      id: MESSAGE_USER_CREDENTIAL_UPDATE,
      options: {
        type: intl.formatMessage({
          id: type === CREDENTIALS_TYPE_PHONE ? "custom.destination.sms" : "custom.destination.email",
        }),
        credential: type === CREDENTIALS_TYPE_PHONE ? user.movilSeguridad : user.emailSeguridad,
      },
    });
  };

  const handleValidateSecurityCredentials = (type) => {
    const body = {
      tipoCredencial: type,
      credencial: type === CREDENTIALS_TYPE_PHONE ? user.movilSeguridad : user.emailSeguridad,
    };

    putValidateSecurityCredentials(idCrm, id, body, handleGetUser, {
      id: MESSAGE_USER_CREDENTIAL_VALIDATE,
      options: {
        type: intl.formatMessage({
          id: type === CREDENTIALS_TYPE_PHONE ? "destination.sms" : "destination.email",
        }),
        credential: type === CREDENTIALS_TYPE_PHONE ? user.movilSeguridad : user.emailSeguridad,
      },
    });
  };

  const handleOpenInfo = (e) => {
    e.preventDefault();
    setOpenInfo((openInfo) => !openInfo);
  };

  const InfoModalContent = () => {
    return (
      <Typography
        dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "custom.info.security_credentials" }) }}
      />
    );
  };

  return (
    <>
      <Accordion expanded={!!expanded.includes(ACCORDION_USER_SECURITY_CREDENTIALS)}>
        <AccordionSummary aria-controls="panel1bh-content" id="panel1bh-header">
          <div className={classes.accordionHeader}>
            <Typography
              onClick={() => handleSetExpanded(ACCORDION_USER_SECURITY_CREDENTIALS)}
              className={classes.accordionTitle}
              variant={"h6"}
            >
              {intl.formatMessage({ id: "custom.user.security_credentials" })}
            </Typography>
            <Button startIcon={<InfoOutlinedIcon />} onClick={handleOpenInfo}>
              {intl.formatMessage({ id: "ra.action.more_info" })}
            </Button>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={4}>
            <Grid item xs={12} container spacing={4}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  disabled
                  //disabled={!user}
                  label={intl.formatMessage({ id: "custom.user.security_email" })}
                  value={securityEmail}
                  variant="outlined"
                  onChange={(e) => handleSetSecurityEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={intl.formatMessage({ id: "custom.user.tooltip_validate_credential" })}
                >
                  <span>
                    <Button
                      startIcon={<CheckCircleOutlineOutlinedIcon />}
                      disabled={!!user?.fechaValidacionEmailSeguridad || !user?.emailSeguridad}
                      onClick={() => handleValidateSecurityCredentials(CREDENTIALS_TYPE_EMAIL)}
                      className={classes.button}
                    >
                      {intl.formatMessage({ id: "ra.action.validate" })}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={intl.formatMessage({ id: "custom.user.tooltip_change_credential" })}
                >
                  <span>
                    <Button
                      startIcon={<SaveOutlinedIcon />}
                      disabled
                      //disabled={!securityEmail || user?.emailSeguridad === securityEmail}
                      onClick={() => handleUpdateSecurityCredentials(CREDENTIALS_TYPE_EMAIL)}
                      className={classes.button}
                    >
                      {intl.formatMessage({ id: "ra.action.save" })}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2}>
                <Button
                  startIcon={<CancelOutlinedIcon />}
                  disabled={securityEmail === user?.emailSeguridad || !securityEmail}
                  onClick={handleRestoreData}
                  className={classes.iconButton}
                >
                  {intl.formatMessage({ id: "ra.action.erase" })}
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2} className={classes.keyValue}>
                <Typography variant={"caption"}>
                  {intl.formatMessage({ id: "custom.user.email_validation" })}
                </Typography>
                <Typography>{formatValidationDate(user?.fechaValidacionEmailSeguridad)}</Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={4}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <TextField
                  disabled
                  //disabled={!user}
                  label={intl.formatMessage({ id: "custom.user.security_phone" })}
                  value={securityPhone}
                  variant="outlined"
                  onChange={(e) => handleSetSecurityPhone(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={intl.formatMessage({ id: "custom.user.tooltip_validate_credential" })}
                >
                  <span>
                    <Button
                      startIcon={<CheckCircleOutlineOutlinedIcon />}
                      disabled={!!user?.fechaValidacionMovilSeguridad || !user?.movilSeguridad}
                      onClick={() => handleValidateSecurityCredentials(CREDENTIALS_TYPE_PHONE)}
                      className={classes.button}
                    >
                      {intl.formatMessage({ id: "ra.action.validate" })}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={intl.formatMessage({ id: "custom.user.tooltip_change_credential" })}
                >
                  <span>
                    <Button
                      startIcon={<SaveOutlinedIcon />}
                      disabled
                      //disabled={!securityPhone || user?.movilSeguridad !== securityPhone}
                      onClick={() => handleUpdateSecurityCredentials(CREDENTIALS_TYPE_PHONE)}
                      className={classes.button}
                    >
                      {intl.formatMessage({ id: "ra.action.save" })}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2}>
                <Button
                  startIcon={<CancelOutlinedIcon />}
                  disabled={securityPhone === user?.movilSeguridad || !securityPhone}
                  onClick={handleRestoreData}
                  className={classes.iconButton}
                >
                  {intl.formatMessage({ id: "ra.action.erase" })}
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={2} className={classes.keyValue}>
                <Typography variant={"caption"}>
                  {intl.formatMessage({ id: "custom.user.phone_validation" })}
                </Typography>
                <Typography>{formatValidationDate(user?.fechaValidacionMovilSeguridad)}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <AlertDialog
        openAlert={openInfo}
        handleClose={handleOpenInfo}
        title={intl.formatMessage({ id: "custom.user.security_credentials" })}
        cancelButtonText={intl.formatMessage({ id: "ra.action.close" })}
        content={<InfoModalContent />}
      />
    </>
  );
};

export default UserCredentialsComponent;
